<template>
    <div name="soldoc-partners-effect" class="soldoc-partners-effect" id="soldoc-partners-effect">
        <div class="soldoc-partners-effect-inner">
            <span class="sub-text">FOR PARTNERS ONLY</span>
            <h3 class="title">솔닥파트너스가<br>다 해드립니다</h3>

            <div class="card-wrap">
                <div class="card-item">
                    <img class="ico" src="../../assets/partners_mobile/ico_soldoc_partners_effect1.png" alt="" />
                    <strong class="card-tit">50만 솔닥 이용자를<br>우리 병원 환자로</strong>
                    <p>누적 진료수 59만 건 돌파,<br>솔닥 이용자는 오직<br>솔닥파트너스에서만 만날 수 있습니다.</p>
                </div>
                <div class="card-item">
                    <img class="ico" src="../../assets/partners_mobile/ico_soldoc_partners_effect2.png" alt="" />
                    <strong class="card-tit">병원 매출,<br>최대 342% 상승</strong>
                    <p>평균 신환 증가율 38%, 재진율 89% 개선<br>기존 도입 의원이 증명하는 검증된 솔루션</p>
                    <span>*2023년 12월 기준 상위 13개 기관</span>
                </div>
                <div class="card-item">
                    <img class="ico" src="../../assets/partners_mobile/ico_soldoc_partners_effect3.png" alt="" />
                    <strong class="card-tit">마케팅부터 물류까지<br>올인원 토탈 케어</strong>
                    <p>병원 마케팅, CS 지원,<br>의료기기 물류 관리까지 솔닥파트너스의<br>병의원 전문 올인원 토탈케어</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "soldoc-partners-effect",
    data: function() {
        return {};
    },
    computed: {},
    mounted: function() {
        $(window).scroll(function() {
            var height = $(document).scrollTop();
            var innerTop = $(".soldoc-partners-effect-inner").offset().top;
            var aniText = $(".soldoc-partners-effect-inner .sub-text");
            var aniTit = $(".soldoc-partners-effect-inner .title");
            var aniItem = $(".soldoc-partners-effect-inner .card-item");

            if (height <= 0) {
                $(aniText).removeClass('item-show').addClass('item-hide');
                $(aniTit).removeClass('item-show').addClass('item-hide');
                $(aniItem).removeClass('item-show').addClass('item-hide');
            } else if (height > innerTop - 500 && height < innerTop + 1000) {
                $(aniText).removeClass('item-hide').addClass('item-show');
                $(aniTit).removeClass('item-hide').addClass('item-show');
                $(aniItem).removeClass('item-hide').addClass('item-show');
            } else if (height > innerTop + 1000) {
                $(aniText).removeClass('item-show').addClass('item-hide');
                $(aniTit).removeClass('item-show').addClass('item-hide');
                $(aniItem).removeClass('item-show').addClass('item-hide');
            }
        });
    },
    methods: {},
};
</script>

<style scoped>
.soldoc-partners-effect {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    height: 1130px;
    background: #0040C9;
    background-image: url(../../assets/partners_mobile/bg_soldoc_partners_effect.png);
    background-size: auto 100%;
    background-position: center center;
    background-repeat: no-repeat;
    overflow: hidden;
}
.soldoc-partners-effect-inner {
    display: flex;
    flex-direction: column;
    width: 100%;
    margin: 0 auto;
    padding-top: 95px;
    padding-bottom: 106px;
}
.soldoc-partners-effect-inner .sub-text {
    font-size: 12px;
    font-weight: 600;
    line-height: 26px;
    color: #FFF;
    text-align: center;
    visibility: hidden;
    opacity: 0;
}
.soldoc-partners-effect-inner .title {
    margin-top: 9px;
    margin-bottom: 0;
    font-size: 30px;
    font-weight: 600;
    line-height: 42px;
    color: #fff;
    text-align: center;
    visibility: hidden;
    opacity: 0;
}
.soldoc-partners-effect-inner .card-wrap {
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin: 48px auto 0;
}
.soldoc-partners-effect-inner .card-item {
    position: relative;
    width: 346px;
    height: 242px;
    margin: 0 auto;
    padding: 39px 32px 32px;
    border-radius: 20px;
    border: 3px solid #008DEF;
    background: #FFF;
    visibility: hidden;
    opacity: 0;
}
.soldoc-partners-effect-inner .item-hide {
    visibility: hidden;
    opacity: 0;
}
.soldoc-partners-effect-inner .item-show {
    visibility: visible;
    opacity: 1;
    animation: fadeInUp1 2s;
}
.soldoc-partners-effect-inner .card-item.item-show {
    visibility: visible;
    opacity: 1;
    animation: fadeInUp2 2s;
}
.soldoc-partners-effect-inner .card-item + .card-item {
    margin-top: 18px;
}
.soldoc-partners-effect-inner .card-item:nth-child(1) .ico {
    position: absolute;
    top: 39px;
    right: 32px;
}
.soldoc-partners-effect-inner .card-item:nth-child(2) .ico {
    position: absolute;
    top: 29px;
    right: 37px;
}
.soldoc-partners-effect-inner .card-item:nth-child(3) .ico {
    position: absolute;
    top: 54px;
    right: 26px;
}
.soldoc-partners-effect-inner .card-tit {
    font-size: 24px;
    font-weight: 600;
    line-height: 34px;
    color: #1A1A1A;
}
.soldoc-partners-effect-inner .card-tit + p {
    margin: 20px 0 0;
    font-size: 16px;
    font-weight: 400;
    line-height: 26px;
    color: #1A1A1A;
}
.soldoc-partners-effect-inner  .card-item span {
    color: #999;
    font-size: 12px;
    font-weight: 400;
    line-height: 30px;
}

@keyframes fadeInUp1 {
    0% {
        opacity: 0;
        transform: translate3d(0, 30%, 0);
    }
    to {
        opacity: 1;
        transform: translateZ(0);
    }
}
@keyframes fadeInUp2 {
    0% {
        opacity: 0;
        transform: translate3d(0, 100%, 0);
    }
    to {
        opacity: 1;
        transform: translateZ(0);
    }
}

@media screen and (max-width: 359px) {
    .soldoc-partners-effect {
        height: auto;
    }
    .soldoc-partners-effect-inner .card-wrap {
        width: 100%;
        padding: 0 20px;
    }
    .soldoc-partners-effect-inner .card-item {
        width: 100%;
        height: auto;
        padding: 20px;
        border-radius: 20px;
        border: 3px solid #008DEF;
        background: #FFF;
    }
    .soldoc-partners-effect-inner .card-tit {
        font-size: 20px;
        line-height: 24px;
    }
    .soldoc-partners-effect-inner .card-tit + p {
        margin: 10px 0 0;
        font-size: 14px;
        line-height: 18px;
    }
    .soldoc-partners-effect-inner .card-item:nth-child(1) .ico {
        top: 20px;
        right: 26px;
        width: 43.4px;
        height: auto;
    }
    .soldoc-partners-effect-inner .card-item:nth-child(2) .ico {
        top: 20px;
        right: 20px;
        width: 53.9px;
        height: auto;
    }
    .soldoc-partners-effect-inner .card-item:nth-child(3) .ico {
        top: 26px;
        right: 20px;
        width: 57.4px;
        height: auto;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/mobile_partners/SoldocPartnersEffect.vue